import { Component, OnInit } from '@angular/core';
import { Store } from '../../store';
import { OverlayService } from '../../services/overlay.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-supplier-stepthrough',
    templateUrl: './supplier-stepthrough.component.html',
    styleUrls: ['./supplier-stepthrough.component.scss']
})
export class SupplierStepthroughComponent implements OnInit {

    doReset = false;
    newRecord = true;
    mode = 'account';

    steps = {
        supplier: { active: false, completed: false },
        address: { active: false, completed: false },
        user: { active: false, completed: false },
        range: { active: false, completed: false },
        productTypes: { active: false, completed: false },
        optionsPricing: { active: false, completed: false },
        confirmation: { active: false, completed: false },
    };
    storedRecord;

    productRange;

    user = {
        id: undefined,
        username: '',
        password: '',
        extendedExpiration: false,
        accountType: 'supplier',
        terms: false,
        marketing: false,
        contact: {
            userId: '',
            companyId: '',
            addressId: '',
            firstname: '',
            surname: '',
            email: '',
            mobile: '',
            landline: '',
            avatar: '',
            jobTitle: '',
        },
        company: undefined,
        address: undefined
    };

    company: any = {
        accountType: 'supplier',
        addressId: '',
        primaryUserId: '',
        name: '',
        url: '',
        email: '',
        mobile: '',
        landline: '',
        companyNumber: '',
        vatNumber: '',
        restrictions: '',
    };

    address: any = {
        add1: '',
        add2: '',
        add3: '',
        town: '',
        county: '',
        country: 'GB',
        postcode: '',
        defaultDeliveryAddress: true,
        isBilling: true,
    };

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        console.log(this.route.snapshot.url)
        if (this.route.snapshot.url.length) {
            this.mode = 'jobLot';
        }
        console.log(this.mode)
        this.setStep('supplier', undefined);
        this.storedRecord = this.store.selectForLocal('supplier');
        if (this.storedRecord) {
            this.company = this.storedRecord;
            this.address = this.storedRecord.address;
            this.user = this.storedRecord.primaryUser;
            this.newRecord = false;
        }
    }

    setStep(stepToActivate, stepToComplete) {
        let stepArray = [];
        if (stepToComplete) {
            stepArray = stepToComplete.split(',');
        }
        if (stepArray.length) {
            stepArray.forEach(step => {
                this.steps[step].active = false;
                this.steps[step].completed = true;
            });
        }
        this.steps[stepToActivate].active = true;
    }

    exitStep(stepToActivate, stepToClose) {
        this.steps[stepToClose].active = false;
        this.steps[stepToActivate].active = true;
    }

    resetSteps() {
        const objKeys = Object.keys(this.steps);

        objKeys.forEach(key => {
            this.steps[key].active = false;
            this.steps[key].completed = false;
        });
        this.steps.supplier.active = true;
        this.doReset = false;
    }

    barNav(step) {
        if (this.canMoveForward(step)) {
            const objKeys = Object.keys(this.steps);
            objKeys.forEach(key => {
                this.steps[key].active = false;
            });

            this.steps[step].active = true;
        }
    }

    canMoveForward(step) {
        switch (step) {
            case 'supplier':
                return true;
                break;
            case 'address':
                if (this.company.name && this.company.email) {
                    return true;
                }
                break;
            case 'user':
                if (this.address.add1 && this.address.town && this.address.postcode) {
                    return true;
                }
                break;
            case 'baseCosts':
                if (this.company.id) {
                    return true;
                }
                break;
            case 'range':
                if (this.company.id) {
                    return true;
                }
                break;
            case 'productTypes':
                if (this.productRange) {
                    return true;
                }
                break;
            case 'optionsPricing':
                if (this.productRange) {
                    return true;
                }
                break;
            default:
                return false;
        }
    }

    confirmResetBasket() {
        this.doReset = true;
    }

    resetCancelled() {
        this.doReset = false;
    }

    cancel() {
        if (this.mode === 'jobLot') {
            this.router.navigate(['/', 'products', 'create-entry'])
        } else {
            this.overlayService.closeAll();
        }
    }

    productRangeUpdated(e) {
        this.productRange = e;
    }

    userCreated(e) {
        this.user = e.user;
        this.address = e.address;
        this.company = e.company;
        this.newRecord = false;
    }

    addProduct() {
        this.cancel();
        this.router.navigate(['/products', 'create']);
    }

}
